const patientModel = {
	"email": "xyz@gmail.com",
	"password" : "test",
	"firstName": "Rajesh",
	"lastName": "Kumar",
	"phone": "+918234590123",
	"address": ["street no 178, Juhu", "Doddankundi Bangalore", "Karnataka Zip 578901"]
}
export default patientModel;